"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));

var _FilterItemHeader = require("./FilterItemHeader");

var _FilterItemFooter = require("./FilterItemFooter");

// Components:
var FilterItem = function FilterItem(props) {
  var value = props.value,
      handleItemClick = props.handleItemClick,
      id = props.id,
      name = props.name,
      minPrice = props.minPrice,
      count = props.count,
      _props$emptyReason = props.emptyReason,
      emptyReason = _props$emptyReason === void 0 ? undefined : _props$emptyReason,
      isHotelOnly = props.isHotelOnly;
  var hasTours = count > 0;
  return /*#__PURE__*/_react["default"].createElement(StyledFilterItem, {
    key: id
  }, /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
    checked: value && value[id] && hasTours,
    "data-id": id,
    onClick: handleItemClick,
    disabled: !hasTours
  }, /*#__PURE__*/_react["default"].createElement(StyledCheckboxWrapper, null, /*#__PURE__*/_react["default"].createElement(_FilterItemHeader.FilterItemHeader, {
    hasTours: hasTours,
    name: name,
    minPrice: minPrice
  }), /*#__PURE__*/_react["default"].createElement(_FilterItemFooter.FilterItemFooter, {
    hasTours: hasTours,
    count: count,
    emptyReason: emptyReason,
    isHotelOnly: isHotelOnly
  }))));
};

exports.FilterItem = FilterItem;

var StyledFilterItem = _styledComponents["default"].div.withConfig({
  displayName: "FilterItem__StyledFilterItem",
  componentId: "sc-1yhuic8-0"
})(["padding:8px 0;&:not(:last-child){border-bottom:1px solid ", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.whiteLight;
});

var StyledCheckbox = (0, _styledComponents["default"])(_Checkbox["default"]).withConfig({
  displayName: "FilterItem__StyledCheckbox",
  componentId: "sc-1yhuic8-1"
})(["height:100%;", "{margin-top:auto;margin-bottom:auto;}"], _Checkbox["default"].StyledWrapper);

var StyledCheckboxWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FilterItem__StyledCheckboxWrapper",
  componentId: "sc-1yhuic8-2"
})(["width:100%;display:flex;flex-direction:column;justify-content:center;"]);